import L from 'leaflet';

import blueMarker from '../assets/blueMarker.svg';
import redMarker from '../assets/redMarker.svg';
import goldMarker from '../assets/goldMarker.svg';
import greenMarker from '../assets/greenMarker.svg';
import liveMarker from '../assets/liveMarker.svg';

export const blueIcon = L.icon({
  iconUrl: blueMarker,
  iconSize: [32, 32],
  iconAnchor: [16, 32],
  popupAnchor: [0, -32],
});

export const redIcon = L.icon({
  iconUrl: redMarker,
  iconSize: [32, 32],
  iconAnchor: [16, 32],
  popupAnchor: [0, -32],
});

export const goldIcon = L.icon({
  iconUrl: goldMarker,
  iconSize: [32, 32],
  iconAnchor: [16, 32],
  popupAnchor: [0, -32],
});

export const greenIcon = L.icon({
  iconUrl: greenMarker,
  iconSize: [32, 32],
  iconAnchor: [16, 32],
  popupAnchor: [0, -32],
});

export const liveIcon = L.icon({
  iconUrl: liveMarker,
  iconSize: [32, 32],
  iconAnchor: [16, 32],
  popupAnchor: [0, -32],
});

